import { Button } from "@studyhub/ui/components/button";
import { EmptyState } from "@studyhub/ui/components/empty-state";
import { IconError404 } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
	const { t } = useTranslation("common");
	return (
		<div className="flex h-[100dvh] w-full flex-col items-center justify-center p-4">
			<EmptyState
				icon={<IconError404 size={48} stroke={1.5} className="text-muted-foreground" />}
				title={t("errors.notFound.title")}
				description={t("errors.notFound.description")}
				action={
					<Button asChild>
						<Link to="/">{t("errors.notFound.home")}</Link>
					</Button>
				}
			/>
		</div>
	);
}
